import { render } from "./ShimmerLoading.vue?vue&type=template&id=1dda317a&scoped=true"
import script from "./ShimmerLoading.vue?vue&type=script&lang=js"
export * from "./ShimmerLoading.vue?vue&type=script&lang=js"

import "./ShimmerLoading.vue?vue&type=style&index=0&id=1dda317a&scoped=true&lang=css"

import exportComponent from "/var/www/likvio.se/html-prod/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dda317a"]])

export default __exports__